import { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import styled from "styled-components";
import Footer from "../../components/footer/Footer";
import Nav from "../../components/navbar/Nav";
// import NavRoute from "./components/NavRoute";
import ProductHero from "./components/ProductHero";

const Product = ({ history }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [step, setStep] = useState(window.location.pathname);
  // const path = window.location.pathname;

  // useEffect(() => {
  //   setStep(path);
  //   console.log({ history: window.location.pathname, step });
  // }, [path]);

  return (
    <div>
      <StickNavProduct>
        <Nav />
      </StickNavProduct>
      <ProductHero />
      <ProductWrap>
        <NavRoutes>
          <Link
            to="/product"
            className={`step ${step === "/product" && "activeStep"}`}
            onClick={() => setStep("/product")}
          >
            Beta Life
          </Link>
          <Link
            to="edu"
            className={`step ${step === "/product/edu" && "activeStep"}`}
            onClick={() => setStep("/product/edu")}
          >
            Children Education Plan
          </Link>
          <Link
            to="jolly-jolly"
            className={`step ${step === "/product/jolly-jolly" && "activeStep"}`}
            onClick={() => setStep("/product/jolly-jolly")}
          >
            Jolly Jolly
          </Link>
          <Link
            to="auto-loan"
            className={`step ${step === "/product/auto-loan" && "activeStep"}`}
            onClick={() => setStep("/product/auto-loan")}
          >
            Auto Loan
          </Link>
          <Link
            to="payday"
            className={`step ${step === "/product/payday" && "activeStep"}`}
            onClick={() => setStep("/product/payday")}
          >
            Payday Credit
          </Link>
          <Link
            to="school-fees"
            className={`step ${step === "/product/school-fees" && "activeStep"}`}
            onClick={() => setStep("/product/school-fees")}
          >
            School Fees Advance
          </Link>
        </NavRoutes>
      </ProductWrap>
      <Outlet />
      {/* <NavRoute /> */}
      <div style={{ marginTop: "-10rem" }}>
        <Footer />
      </div>
    </div>
  );
};

export default Product;

export const StickNavProduct = styled.div`
  position: fixed;
  width: 100%;
  transform: translateY(-6rem);
  margin-bottom: 2rem;
  z-index: 10000;
`;

export const ProductWrap = styled.div`
  transform: translateY(-7rem);
  background-color: #dbdbf9;
`;

export const NavRoutes = styled.div`
  transform: translateY(-3rem);
  background-color: #fff;
  padding-top: 37px;
  padding-bottom: 43px;
  max-width: 1280px;
  margin: auto;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.16);

  a {
    // padding-left: 1rem;
    margin-right: 2rem;
    font-size: 20px;
    cursor: pointer;
    // background-color: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.secondary};
    padding: 0.8rem 0.1rem;
  }

  .active {
    border-bottom: 3px solid ${({ theme }) => theme.colors.secondary};
    padding: 8px 0px;
  }

  .step:first-child {
    // border: 2px solid red;
    padding-left: 2rem;
  }
  .step {
    font-size: 20px;
    margin-right: 64x;
    cursor: pointer;
    margin-right: 1rem;
    padding: 0.8rem 0.5rem;
  }

  .activeStep {
    // font-size: 20px;
    // margin-right: 64px;
    // cursor: pointer;
    background-color: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.text};
    // font-weight: 600;
  }

  // @media screen and (max-width: 991px) {
  //   span {
  //     // padding-left: 1rem;
  //     margin-right: 3rem;
  //     font-size: 20px;
  //     cursor: pointer;
  //     // background-color: ${({ theme }) => theme.colors.secondary};
  //     color: ${({ theme }) => theme.colors.secondary};
  //     padding: 0.8rem 0.2rem;
  //   }
  // }
  @media screen and (max-width: 991px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0rem;

    .step:first-child {
      padding-left: 1rem;
    }
    
    a {
      border-radius: 4px;
      // padding-left: 1rem;
      margin-left: 1rem;
      font-size: 16px;
      cursor: pointer;
      // background-color: ${({ theme }) => theme.colors.secondary};
      color: ${({ theme }) => theme.colors.secondary};
      // padding: 0.8rem 0.1rem;
    }
    .step {
      font-size: 16px;
      // margin-right: 64x;
      cursor: pointer;
      // margin-right: 1rem;
      // padding: 0.8rem 0.1rem;
    }
    .activeStep {
      // font-size: 20px;
      padding-left: 1rem;
      // cursor: pointer;
      background-color: ${({ theme }) => theme.colors.secondary};
      color: ${({ theme }) => theme.colors.text};
      // font-weight: 600;
    }
  }
`;
